module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAAAqAQMAAAA9PR+cAAAABlBMVEVHcEz///+flKJDAAAAAXRSTlMAQObYZgAAABZJREFUGNNj+A8FBxhIZ1ECRu0lmgUAycnRQcOs4uQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tbm/sidebar.png
// module id = cmC1
// module chunks = 40